__webpack_require__.p = "/Chandrashekhar-Prajapati-Portfolio/";